import { render, staticRenderFns } from "./main-layout-vertical.vue?vue&type=template&id=7e5e76c2&scoped=true"
import script from "./main-layout-vertical.vue?vue&type=script&lang=js"
export * from "./main-layout-vertical.vue?vue&type=script&lang=js"
import style0 from "./main-layout-vertical.vue?vue&type=style&index=0&id=7e5e76c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5e76c2",
  null
  
)

export default component.exports